import api from './api';

// Alle Themenkörbe der Familie abrufen
export const getCollections = async () => {
  try {
    const response = await api.get('/collections');
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Abrufen der Themenkörbe:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Abrufen der Themenkörbe' 
    };
  }
};

// Einzelnen Themenkorb mit Artikeln abrufen
export const getCollection = async (collectionId) => {
  try {
    const response = await api.get(`/collections/${collectionId}`);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Abrufen des Themenkorbs:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Abrufen des Themenkorbs' 
    };
  }
};

// Neuen Themenkorb erstellen
export const createCollection = async (collectionData) => {
  try {
    const response = await api.post('/collections', collectionData);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Erstellen des Themenkorbs:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Erstellen des Themenkorbs' 
    };
  }
};

// Themenkorb aktualisieren
export const updateCollection = async (collectionId, collectionData) => {
  try {
    const response = await api.put(`/collections/${collectionId}`, collectionData);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Aktualisieren des Themenkorbs:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Aktualisieren des Themenkorbs' 
    };
  }
};

// Themenkorb löschen (soft delete)
export const deleteCollection = async (collectionId) => {
  try {
    const response = await api.delete(`/collections/${collectionId}`);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Löschen des Themenkorbs:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Löschen des Themenkorbs' 
    };
  }
};

// Artikel zu Themenkorb hinzufügen
export const addItemToCollection = async (collectionId, articleId) => {
  try {
    const response = await api.post(`/collections/${collectionId}/items`, { article_id: articleId });
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Hinzufügen des Artikels:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Hinzufügen des Artikels' 
    };
  }
};

// Artikel aus Themenkorb entfernen
export const removeItemFromCollection = async (collectionId, itemId) => {
  try {
    const response = await api.delete(`/collections/${collectionId}/items/${itemId}`);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Entfernen des Artikels:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Entfernen des Artikels' 
    };
  }
};

// Reihenfolge der Artikel im Themenkorb ändern
export const reorderCollectionItems = async (collectionId, items) => {
  try {
    const response = await api.put(`/collections/${collectionId}/items/reorder`, { items });
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Fehler beim Ändern der Reihenfolge:', error);
    return { 
      success: false, 
      error: error.response?.data?.error || 'Fehler beim Ändern der Reihenfolge' 
    };
  }
};
